export const primitiveSpacing = {
	1: '1rem',
	2: '2rem',
	3: '3rem',
	4: '4rem',
	6: '6rem',
	8: '8rem',
} as const;

export const padding = {
	xLarge: primitiveSpacing[8],
	large: primitiveSpacing[6],
	normal: primitiveSpacing[3],
	small: primitiveSpacing[2],
	xSmall: primitiveSpacing[1],
} as const;
